<div class="footer">
  <div class="container">
    <div class="row-footer">
      <div class="column-footer column-footer-logo">
        <a href="https://nmfta.org">
          <img class="nmfta-logo" src="assets/images/nmfta-logo.svg" alt="NMFTA Logo" />
        </a>
        <p class="small-font mt-3 column-box">
          1001 N Fairfax Street Suite 600 Alexandria, Virginia 22314-1798 (866) 411-6632
        </p>
      </div>
      <div class="column-footer w-100">
        <ul class="right-panel">
          <li>
            <strong class="me-4">
              <a href="https://nmfta.org/support/" target="_blank"> Contact Support </a>
            </strong>
            <strong class="me-4">
              <a href="https://help.nmfta.org/hc/en-us" target="_blank"> {{ 'Generic_HelpCenter' | translate }} </a>
            </strong>
            <strong class="me-4">
              <a href="https://nmfta.org/" target="_blank"> NMFTA Home</a>
            </strong>
            <strong>
              <a href="https://nmfta.org/nmfc/" target="_blank"> About The NMFC</a>
            </strong>
          </li>
          <li>
            <div class="d-flex social-container w-auto align-items-center">
              <a href="https://www.facebook.com/NMFTA" target="_blank">
                <img class="social-images-footer me-2" src="./assets/icons/facebook.svg" alt="Facebook Link" />
              </a>
              <a href="https://twitter.com/nmfta" target="_blank"
                ><img class="social-images-footer me-2" src="./assets/icons/xtwitter.svg" alt="X Link" />
              </a>
              <a
                href="https://www.linkedin.com/company/national-motor-freight-traffic-association-inc./"
                target="_blank">
                <img class="social-images-footer me-2" src="./assets/icons/linkedin.svg" alt="Linkedin Link" />
              </a>
              <a href="https://instagram.com/nmftanews" target="_blank">
                <img class="social-images-footer me-2" src="./assets/icons/instagram.svg" alt="Instagram Link" />
              </a>
              <a href="https://www.youtube.com/@nmftassoc" target="_blank">
                <img class="social-images-footer" src="./assets/icons/youtube.svg" alt="Youtube Link" />
              </a>
            </div>
          </li>
          <li class="small-font">
            <p class="w-auto text-end"
              >All content &copy; Copyright {{ currentYear }} National Motor Freight Traffic Association, Inc.<sup
                >&trade;</sup
              >
              All Rights Reserved.
            </p>
          </li>
          <li class="small-font text-end">
            <p class="">
              <a href="https://nmfta.org/privacy/" class="me-1">Privacy Policy</a>
              |
              <a href="https://nmfta.org/terms-of-use/" class="mx-1"> Terms of Use </a>
              |
              <a href="https://nmfta.org/terms-of-sale/" class="mx-1"> Terms of Sale </a>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
